<!-- キーワードから探す プルダウン -->
<template>
  <div class="crly-a-common-search-keyword-pulldown-select icon">
    <select
      @change="changePulldown"
      v-model="pulldown"
      class="crly-a-common-search-keyword-pulldown-select__phone"
      >
      <template v-for="(item, index) in list">
        <template>
          <option :key="index" :value="item.value">
            {{ item.name }}
          </option>
        </template>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordPulldown",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pulldown: ""
    };
  },
  /**
   * 検索内容選択
   */
  methods: {
    changePulldown() {
      let select = this.list.find((element) => element.value === this.pulldown);
      this.$emit("changePulldown", select);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/pulldownSelect.scss";
</style>
